import palette from './palette';

const typography = {
  fontFamily: [
    'Circular',
    'Roboto',
    '"Helvetica Neue"',
    'Arial',
    'sans-serif',
  ].join(','),
  h1: {
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: '35px',
    lineHeight: '40px',
  },
  h2: {
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: '29px',
    lineHeight: '32px',
  },
  h3: {
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: '24px',
    lineHeight: '28px',
  },
  h4: {
    color: palette.text.primary,
    fontWeight: 700,
    fontSize: '34px',
    lineHeight: '123.5%',
  },
  h5: {
    color: palette.text.primary,
    fontWeight: 700,
    fontSize: '24px',
    lineHeight: '133.4%',
  },
  h6: {
    color: palette.text.primary,
    fontWeight: 700,
    fontSize: '20px',
    lineHeight: '160%',
  },
  subtitle1: {
    color: palette.text.primary,
    fontSize: '16px',
    lineHeight: '150%',
    fontWeight: 500,
  },
  subtitle2: {
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '143%',
  },
  body1: {
    color: palette.text.primary,
    fontSize: '16px',
    lineHeight: '150%',
  },
  body2: {
    color: palette.text.primary,
    fontSize: '14px',
    lineHeight: '143%',
  },
  button: {
    textTransform: 'none' as const,
    color: palette.text.primary,
    fontSize: '14px',
  },
  caption: {
    color: palette.text.secondary,
    fontSize: '13px',
    lineHeight: '166%',
  },
  overline: {
    color: palette.text.secondary,
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '266%',
    textTransform: 'uppercase' as const,
  },
  tableHeader: {
    fontSize: '14px',
    fontWeight: 400,
    color: palette.text.tertiary,
    lineHeight: '16px',
    fontFamily: 'Circular',
  },
  helpText: {
    fontSize: '12px',
    lineHeight: '18px',
    color: 'rgba(0, 0, 0, 0.38)',
  },
};

export default typography;
